export function singleCollapse() {

	$('.js-singleCollapseBtn').click(function() {
		$('.js-singleCollapse.in').collapse('hide');
	});

}
